import store from '../store';
import steps from './stepsMan';
import buildConfigMan from './buildConfigMan';
import * as configs from './configsMan';

const questions = {
	setup: ({ questionsDataType, predifinedAnswers }) => {
		const questionsList = {};

		Object.entries(questionsDataType).forEach(question => {
			questionsList[question[0]] = questions.createQuestion({
				name: question[0],
				details: questionsDataType[question[0]],
				...(predifinedAnswers && { predifinedAnswers })
			});
		});

		store.dispatch({
			type: 'SET_QUESTIONS',
			payload: questionsList
		});
	},
	createQuestion: ({ name, details, predifinedAnswers = null }) => {
		const savedAnswers = predifinedAnswers && predifinedAnswers[name];
		const gender = store.getState().global.initialGender;

		const { options } = details;

		if (name === 'body_type' || name === 'goal') {
			Object.entries(options).forEach(item => {
				if (item[1].gender && gender !== item[1].gender) {
					delete options[item[1].value];
				}
			});
		}

		return {
			name: name || '',
			options,
			answers: details.answers || savedAnswers || {}
		};
	},
	saveAnswersData: () => {
		const questionsList = store.getState().questions.list;

		const questionsToSave = {};

		Object.entries(questionsList).forEach(item => {
			const answer = item[1].answers;

			Object.entries(answer).forEach(property => {
				if (property[1].description) delete property[1].description;
				if (property[1].gender) delete property[1].gender;
			});

			questionsToSave[item[1].name] = answer;
		});

		store.dispatch({
			type: 'SAVE_ANSWERS',
			payload: questionsToSave
		});
	},
	addAnswer: ({ questionName, answer }) => {
		const questionsList = { ...store.getState().questions.list };

		questionsList[questionName].answers = {
			...questionsList[questionName].answers,
			[answer.value]: {
				...answer
			}
		};

		store.dispatch({
			type: 'SET_QUESTIONS',
			payload: questionsList
		});

		questions.saveAnswersData();
	},
	addOnlyAnswer: ({ questionName, answer }) => {
		const questionsList = { ...store.getState().questions.list };
		const configName = store.getState().steps.config;
		const configToApply = configName in configs ? configName : 'defaultConfig';
		const answerValue = answer.value ? answer.value : answer;

		if (questionName === 'goal') {
			const modifiedConfig = [...configs[configToApply]];
			const goal = modifiedConfig.findIndex(el => el.name === 'goal');

			if (goal && (answer === 'lose_weight' || answer === 'gain_muscles')) {
				modifiedConfig.splice(goal + 3, 0, { name: 'target_weight' });
				modifiedConfig.splice(goal + 4, 0, { name: 'fat' });
			}

			steps.setup({
				stepsConfig: buildConfigMan({ config: modifiedConfig, configToApply }),
				currentStep: 'goal',
				stepsDetails: configs.stepsDetails
			});
		}

		if (questionName === 'muscle_focus') {
			const modifiedConfig = [...configs[configToApply]];
			const muscleFocus = modifiedConfig.findIndex(el => el.name === 'muscle_focus');

			if (muscleFocus && answer === 'yes') {
				modifiedConfig.splice(muscleFocus + 1, 0, { name: 'zones' });
			}

			steps.setup({
				stepsConfig: buildConfigMan({ config: modifiedConfig, configToApply }),
				currentStep: 'muscle_focus',
				stepsDetails: configs.stepsDetails
			});
		}

		questionsList[questionName].answers = {
			[answerValue]: {
				value: answerValue
			}
		};

		store.dispatch({
			type: 'SET_QUESTIONS',
			payload: questionsList
		});

		questions.saveAnswersData();
	},
	setAnswer: ({ questionName, answerName, answerValue }) => {
		const questionsList = { ...store.getState().questions.list };

		questionsList[questionName].answers = {
			...questionsList[questionName].answers,
			[answerName]: answerValue
		};

		store.dispatch({
			type: 'SET_QUESTIONS',
			payload: questionsList
		});

		questions.saveAnswersData();
		questions.setAnswerExtraEffects({ questionName });
	},
	removeAnswer: ({ questionName, answer }) => {
		const questionsList = { ...store.getState().questions.list };

		delete questionsList[questionName].answers[answer.value];

		store.dispatch({
			type: 'SET_QUESTIONS',
			payload: questionsList
		});

		questions.saveAnswersData();
	},
	toggleAnswer ({ questionName, answer }) {
		const thisAnswerSelected = questions.isAnswerSelected({
			questionName,
			answer: answer.value
		});

		if (!thisAnswerSelected) {
			questions.addAnswer({
				questionName,
				answer
			});
		} else {
			questions.removeAnswer({
				questionName,
				answer
			});
		}
	},
	isAnswerSelected ({ questionName, answer }) {
		const questionsList = { ...store.getState().questions.list };

		return questionsList[questionName].answers[answer];
	},
	getAnswers ({ questionName }) {
		const questionsList = { ...store.getState().questions.list };

		return (questionsList[questionName] && questionsList[questionName].answers) || null;
	},
	setAnswerExtraEffects ({ questionName }) {
		const preSelectUnits = questionName === 'weight' || questionName === 'height' || questionName === 'target_weight';

		function checkUnits ({ name, units }) {
			return (
				questions.getAnswers({ questionName: name }).units &&
        questions.getAnswers({ questionName: name }).units.value === units
			);
		}

		function isEmptyValue ({ name }) {
			return !(
				questions.getAnswers({ questionName: name }).value && questions.getAnswers({ questionName: name }).value.value
			);
		}

		if (preSelectUnits) {
			const unitsAnswer = questions.getAnswers({ questionName });

			if (!unitsAnswer.units) return;

			const metricSystem = unitsAnswer.units.value === 'kg' || unitsAnswer.units.value === 'cm';
			const { preventUnitsChanges } = store.getState().questions;
			const unitsToUse = metricSystem ? 'metric' : 'imperial';

			const units = {
				metric: {
					height: 'cm',
					weight: 'kg'
				},
				imperial: {
					height: 'ft',
					weight: 'lbs'
				}
			};

			if (unitsAnswer.units) {
				if (
					!preventUnitsChanges.height &&
          !checkUnits({ name: 'height', units: units[unitsToUse].height }) &&
          isEmptyValue({ name: 'height' })
				) {
					questions.setAnswer({
						questionName: 'height',
						answerName: 'units',
						answerValue: { value: units[unitsToUse].height }
					});
				}

				if (
					!preventUnitsChanges.weight &&
          !checkUnits({ name: 'weight', units: units[unitsToUse].weight }) &&
          isEmptyValue({ name: 'weight' })
				) {
					questions.setAnswer({
						questionName: 'weight',
						answerName: 'units',
						answerValue: { value: units[unitsToUse].weight }
					});
				}

				if (
					!preventUnitsChanges.target_weight &&
          !checkUnits({ name: 'target_weight', units: units[unitsToUse].weight }) &&
          isEmptyValue({ name: 'target_weight' })
				) {
					questions.setAnswer({
						questionName: 'target_weight',
						answerName: 'units',
						answerValue: { value: units[unitsToUse].weight }
					});
				}
			}
		}
	},
	preventUnitsChanges ({ name }) {
		const { preventUnitsChanges } = store.getState().questions;

		store.dispatch({
			type: 'PREVENT_UNITS_CHANGES',
			payload: {
				...preventUnitsChanges,
				[name]: true
			}
		});
	}
};

export default questions;
